export enum DropdownItemType {
    Title = 'title',
    Separator = 'separator',
    Link = 'link',
}
